import { UIHeading2, UIHeading4 } from '@cian/ui-kit/typography';
import { memo } from 'react';

import styles from './Title.css';
import { GeneralInfoSectionRow } from '../GeneralInfoSectionRow';

interface ITitleProps {
  title: string;
  subtitle?: string | null;
  href: string;
  isTop: boolean;
}

export const Title = memo<ITitleProps>(function Title({ title, subtitle, href, isTop }) {
  return (
    <GeneralInfoSectionRow>
      <a className={styles['link']} href={href} target="_blank" rel="noreferrer">
        <UIHeading2
          data-mark="OfferTitle"
          color={isTop || subtitle !== undefined ? 'text-main-default' : 'text-primary-default'}
        >
          {title}
        </UIHeading2>
        {subtitle && (
          <div className={styles['subtitle']}>
            <UIHeading4 data-mark="OfferSubtitle">{subtitle}</UIHeading4>
          </div>
        )}
      </a>
    </GeneralInfoSectionRow>
  );
});
